export default "__VITE_ASSET__B0O3dlHD__"